export default __webpack_public_path__ + "img/27-scoops-of-gelato.4aaebbeb.jpg";